import {Component, computed, effect, Injector, signal, Signal} from "@angular/core";
import {BasicMaterialDialog, MatDialogDataBaseInput} from "../../basic-material-dialog/basic-material-dialog.directive";

export interface DialogData_ClinicalVignetteDialogInput extends MatDialogDataBaseInput {
	clinicalVignetteText: string;
	phaseStartTime?: Signal<Date>;
	clinicalVignetteDurationInSeconds?: number;
	hideRemainingTime?: boolean;
}

@Component({
	selector: "sim-clinical-vignette-dialog",
	templateUrl: "./clinical-vignette-dialog.component.html",
	styleUrl: "./clinical-vignette-dialog.component.scss",
	standalone: false,
})
export class ClinicalVignetteDialogComponent extends BasicMaterialDialog<
	ClinicalVignetteDialogComponent,
	DialogData_ClinicalVignetteDialogInput
> {
	public constructor(injector: Injector) {
		super(injector);
		effect(() => this._currentTimeEffect(this.data.phaseStartTime));
	}

	protected hideRemainingTime = computed(() => this.data.hideRemainingTime);
	protected remainingTime = computed(() => this._calculateRemainingTime(this._currentTime()));
	private _currentTime = signal(Date.now());

	private _currentTimeEffect(phaseStartTime?: Signal<Date>) {
		// In the assessment editor we don't have the phase start time and the clinical vignette duration
		// So we don't need to start the interval, we just show a constant remaining time of 1:59
		if (!phaseStartTime) {
			return;
		}

		const interval = setInterval(() => {
			this._currentTime.set(Date.now());
		}, 250);

		return () => clearInterval(interval);
	}

	private _calculateRemainingTime(currentTimeMs: number) {
		if (this.data.phaseStartTime && this.data.clinicalVignetteDurationInSeconds) {
			const clinicalVignetteEndTimeMs = this.data.phaseStartTime().getTime() + this.data.clinicalVignetteDurationInSeconds * 1000;
			return Math.max(0, Math.ceil((clinicalVignetteEndTimeMs - currentTimeMs) / 1000));
		} else {
			// In the assessment editor we don't have the phase start time and the clinical vignette duration
			// So we fake remaining time to 1:59
			return 119;
		}
	}
}
